import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bg-white divide-y" }
const _hoisted_3 = {
  key: 0,
  class: "flex"
}
const _hoisted_4 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_5 = { class: "flex-1 p-2 text-left" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_8 = { class: "flex-1 p-2 text-left" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_11 = { class: "flex-1 p-2 text-left" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_14 = { class: "flex-1 p-2 text-left" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_17 = { class: "flex-1 p-2 text-left" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_20 = { class: "flex-1 p-2 text-left" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_23 = { class: "flex-1 p-2 text-left" }

import { ref, computed, PropType, watch } from "vue";
import Modal from "@/components/common/Modal.vue";
import { DocumentDataService } from "@/services";
import DocumentFiles from "@/types/documents/document/DocumentFiles";

interface SignInfo {
  iin: string;
  bin?: string | null;
  personType: string;
  serialNumber: string;
  signDate: string;
  signerInfo: string;
  userCertNotAfter: string;
  userCertNotBefore: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  processUserId: {
    type: String,
    default: null,
  },
  documentFiles: {
    type: Array as PropType<Array<DocumentFiles>>,
    default: () => [],
  },
  documentId: {
    type: String,
    default: null,
  },
},
  emits: ["hide"],
  setup(__props, { emit }) {

const props = __props




const signInfo = ref<SignInfo | null>(null);
const showBin = computed(() => Boolean(signInfo.value?.bin && signInfo.value?.iin));

const loadSignInfo = async () => {
  if (!props.show || !props.documentId || !props.processUserId) {
    return;
  }

  await DocumentDataService.getSignInfo(
    props.documentId,
    null,
    props.processUserId
  )
    .then((result) => {
      signInfo.value = result.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

watch(
  () => props.show,
  async (show) => {
    signInfo.value = null;
    if (show) {
      await loadSignInfo();
    }
  },
  { immediate: true }
);

watch(
  () => props.processUserId,
  async () => {
    signInfo.value = null;
    await loadSignInfo();
  }
);

watch(() => props.documentId, async () => {
  signInfo.value = null;
  await loadSignInfo();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hide'))),
    show: __props.show,
    title: _ctx.$t('signInfo.title')
  }, {
    default: _withCtx(() => [
      (signInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("ul", _hoisted_2, [
              (_unref(showBin))
                ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("signInfo.bin")), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(signInfo.value.bin), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("signInfo.iin")), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(signInfo.value.iin), 1)
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("signInfo.type")), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(signInfo.value.personType), 1)
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("signInfo.serialNumber")), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(signInfo.value.serialNumber), 1)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("signInfo.signDate")), 1),
                _createElementVNode("p", _hoisted_17, _toDisplayString(signInfo.value.signDate), 1)
              ]),
              _createElementVNode("li", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("signInfo.fullName")), 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString(signInfo.value.signerFio), 1)
              ]),
              _createElementVNode("li", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("signInfo.certPeriod")), 1),
                _createElementVNode("p", _hoisted_23, _toDisplayString(signInfo.value.userCertNotBefore) + " - " + _toDisplayString(signInfo.value.userCertNotAfter), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})